// Tungi (dark) rejim — Tailwind `darkMode: 'class'`: <html class="dark"> bo'lsa `dark:` variantlar ishlaydi.
// Tanlov localStorage.kh_theme ('light' | 'dark') da saqlanadi; tanlov bo'lmasa tizim sozlamasi
// (prefers-color-scheme) va u o'zgarsa ergashadi. index.js da initTheme() render'dan OLDIN chaqiriladi
// (CSP inline skriptga ruxsat bermaydi, shuning uchun HTML'ga qo'yib bo'lmaydi — bundle yuklangach qo'llanadi).
import { useEffect, useState } from 'react';

const KEY = 'kh_theme';
const mq = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

export function storedTheme() {
  try { const v = localStorage.getItem(KEY); return v === 'dark' || v === 'light' ? v : null; } catch { return null; }
}
export function resolveTheme() {
  return storedTheme() || (mq && mq.matches ? 'dark' : 'light');
}
export function applyTheme(t) {
  const dark = t === 'dark';
  document.documentElement.classList.toggle('dark', dark);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', dark ? '#111827' : '#1a56db');
  window.dispatchEvent(new CustomEvent('kh:theme', { detail: t }));
}
export function setTheme(t) {
  try { localStorage.setItem(KEY, t); } catch {}
  applyTheme(t);
}
export function initTheme() {
  applyTheme(resolveTheme());
  if (mq && mq.addEventListener) mq.addEventListener('change', () => { if (!storedTheme()) applyTheme(resolveTheme()); });
}
// React hook: [theme, toggle] — toggle() = light↔dark, toggle('dark') = aniq qiymat.
export function useTheme() {
  const [theme, set] = useState(resolveTheme);
  useEffect(() => {
    const h = (e) => set(e.detail);
    window.addEventListener('kh:theme', h);
    return () => window.removeEventListener('kh:theme', h);
  }, []);
  return [theme, (t) => setTheme(t || (theme === 'dark' ? 'light' : 'dark'))];
}
